module.exports = __webpack_public_path__ + "img/warum_mehr_glueckliche_menschen.d590324f.png";